<gpu-form-field [appearance]="formFieldAppearance">
  <gpu-label>{{ question.answers[0].name }}</gpu-label>
  <input
    id="input_0_{{ question.answers[0].id }}"
    name="input_0_{{ question.answers[0].id }}"
    type="text"
    gpuInput
    appMobileScrollOnFocus
    gpuLocalNumber
    formControlName="value"
    [focused]="true"
    (blur)="track()"
  />
  <gpu-error *ngIf="form.controls.value?.errors?.required">
    {{ 'ANALYSES.VALUE_REQUIRED' | translate }}
  </gpu-error>
  <gpu-error *ngIf="form.controls.value?.errors?.max">
    {{ 'ANALYSES.SINGLE.MAX_REFERENCE_VALUE' | translate }}
  </gpu-error>
  <gpu-error *ngIf="form.controls.value.errors?.pattern">
    {{ 'ANALYSES.VALUE_INVALID' | translate }}
  </gpu-error>
</gpu-form-field>
